import { render, staticRenderFns } from "./ClusterTopMatter.vue?vue&type=template&id=2ebbc46c"
import script from "./ClusterTopMatter.vue?vue&type=script&lang=ts"
export * from "./ClusterTopMatter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports